// extracted by mini-css-extract-plugin
export default {"gridCont":"AttributeManagement_gridCont__A-Qbv"};